import React from 'react';

/**
 * Date and time template
 */
export const DateTimeTemplate: React.FC<{ dateString: string }> = ({ dateString }) => {
  const date = new Date(dateString);

  return (
    <div
      style={{
        padding: '8px 4px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          fontWeight: 500,
          fontSize: '0.875rem',
          color: '#1e293b',
          lineHeight: 1.2,
        }}
      >
        {date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })}
      </div>
      <div
        style={{
          fontSize: '0.75rem',
          color: '#64748b',
          lineHeight: 1.2,
          marginTop: '2px',
        }}
      >
        {date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })}
      </div>
    </div>
  );
};

export default DateTimeTemplate;
